import React from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_ORGS_PATH, ADMIN_ORG_DETAILS_PATH } from '../../../constants/routes';

const BreadCrumb = ({ contextName, contextId, breadcrumb }) => (
    <div className="ckp-admin-breadcrumb">
        <ul className="ckp-admin-breadcrumb-items ckp-ts-h3">
            <Link
                to={contextId ? ADMIN_ORG_DETAILS_PATH.replace(':context', contextId) : ADMIN_ORGS_PATH}
                className={`ckp-admin-breadcrumb-item ${breadcrumb.length ? 'has-next' : ''}`}
            >
                {contextName}
            </Link>
            {breadcrumb.map((b, i) => (
                <Link
                    key={i + b.link}
                    to={b.link}
                    className={`ckp-admin-breadcrumb-item ${i === breadcrumb.length - 1 ? '' : 'has-next'}`}
                >
                    {b.label}
                </Link>
            ))}
        </ul>
    </div>
);

export default BreadCrumb;



// WEBPACK FOOTER //
// ./src/components/admin/layout/BreadCrumb.js